module.exports = __webpack_public_path__ + "static/media/cloud.405cb373.glb";